export const saveFile = ({
  fileData,
  fileName,
}: {
  fileData: any;
  fileName: string;
}) => {
  const element = document.createElement('a');
  element.href = window.URL
    ? window.URL.createObjectURL(fileData)
    : window.webkitURL.createObjectURL(fileData);

  element.addEventListener('click', e => e.stopPropagation());
  element.setAttribute('download', fileName);
  element.style.display = 'none';

  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
